import React from 'react';
import { motion } from 'framer-motion';

const GeschichteSection = () => {
  const milestones = [
    {
      year: '2008',
      title: 'Private Investor Tätigkeit',
      description: 'Private Investor in der Immobilienbranche mit Fokus auf renditestarke Wohn- und Mischimmobilien sowie der strategischen Entwicklung und Wertsteigerung von Bestandsobjekten.',
    },
    {
      year: '2022',
      title: 'Gründung YADE Home GmbH',
      description: 'Gründung der Immobilien GmbH mit Fokus auf Bau, Vermarktung und Verkauf eigener Neubauprojekte, sowie Weiterentwicklung von Bestandsprojekten mit dem übergreifenden Ziel investierbare Wohnräume für alle zu schaffen.',
    },
    {
      year: '2022',
      title: 'Erstes Wohnbauprojekt',
      description: 'Erfolgreiche Realisierung eines Wohnkomplexes in Rösrath mit 20 Wohneinheiten. Verkauf innerhalb von 6 Monaten.',
    },
    {
      year: '2023',
      title: 'Digitalisierung',
      description: 'Implementierung moderner Vermarktungstools: 3D-Visualisierungen, virtuelle Rundgänge und digitale Objektpräsentation.',
    },
    {
      year: '2023',
      title: 'Regionale Expansion',
      description: 'Strategische Erweiterung des Geschäftsgebiets auf Mönchengladbach. Aufbau eines regionalen Partnernetzwerks.',
    },
    {
      year: '2024',
      title: 'Nachhaltigkeit & Innovation',
      description: 'Spezialisierung auf energieeffiziente Gebäude und zukunftsorientierte Wohnkonzepte mit nachhaltigen Baumaterialien.',
    },
    {
      year: '2025',
      title: 'Marktetablierung & Skalierung',
      description: 'Etablierung im Markt durch die Umsetzung mehrerer eigener Immobilienprojekte und den Ausbau eines skalierbaren Geschäftsmodells mit stetig wachsendem Investiervolumen.',
    },
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background year numbers */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]">
        <div className="absolute top-[10%] left-[5%]">
          <span className="text-[180px] font-black text-black">2018</span>
        </div>
        <div className="absolute top-[40%] right-[10%]">
          <span className="text-[160px] font-black text-black">2022</span>
        </div>
        <div className="absolute bottom-[15%] left-[15%]">
          <span className="text-[200px] font-black text-black">2024</span>
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">Unsere Entwicklung</h2>
          <p className="text-gray-700 max-w-3xl mx-auto text-lg">
            Kontinuierliches Wachstum und strategische Weiterentwicklung seit 2018. Von lokalem Immobiliendienstleister zu regionalem Marktführer.
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto">
          {milestones.map((milestone, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className={`flex ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'} mb-16 last:mb-0`}
            >
              {/* Year column */}
              <div className="w-24 md:w-48 flex flex-col items-center">
                <div className="w-16 h-16 rounded-full bg-[#00C2CC] flex items-center justify-center text-white font-bold text-xl">
                  {milestone.year}
                </div>
                <div className="h-full w-0.5 bg-gray-200 my-4"></div>
              </div>
              
              {/* Content column */}
              <div className={`flex-1 ${index % 2 === 0 ? 'pl-4 md:pl-0' : 'pr-4 md:pr-0'}`}>
                <div className="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                  <h3 className="text-xl font-bold mb-3">{milestone.title}</h3>
                  <p className="text-gray-600">{milestone.description}</p>
                </div>
              </div>
              
              {/* Spacer for alternating layout */}
              <div className="w-24 md:w-48 hidden md:block"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GeschichteSection;
